import { emptyApi } from '@/app/store/api/emptyApi';
import { ClientUserControllerUpdateApiArg, ClientUserControllerUpdateApiResponse } from '@/app/store/api/restApi';

export const userApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    updateUserController: build.mutation<ClientUserControllerUpdateApiResponse, ClientUserControllerUpdateApiArg>({
      query: ({ clientUpdateUserDto }) => ({ method: 'POST', url: `user/update`, body: clientUpdateUserDto }),
    }),
  }),
});

export const { useUpdateUserControllerMutation } = userApi;
